/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : DASHBOARD : HOME : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	home: {
		'& #content': {
			'& .message': {
				opacity: '0',
				animationName: 'fadeInDown',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '0s'
			}
		}
	}
});